import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { N20A } from '@atlaskit/theme/colors';
import messages from '../../utils/i18n/messages';
import { TextSkeleton } from '../text-skeleton';
import { ContentFailureMessage, ContentSkeleton } from './styled';
export var DocumentError = function DocumentError() {
  return /*#__PURE__*/React.createElement(ContentSkeleton, null, /*#__PURE__*/React.createElement(ContentFailureMessage, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.contentLoadFailure)));
};
export var DocumentSkeleton = function DocumentSkeleton(_ref) {
  var testId = _ref.testId;
  return /*#__PURE__*/React.createElement(ContentSkeleton, {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(TextSkeleton, {
    width: "100%",
    marginBottom: "4px",
    color: "var(--ds-background-neutral, ".concat(N20A, ")"),
    height: "18px"
  }), /*#__PURE__*/React.createElement(TextSkeleton, {
    width: "60%",
    marginBottom: "0",
    color: "var(--ds-background-neutral, ".concat(N20A, ")"),
    height: "18px"
  }));
};
export { SkeletonBox } from './styled';